import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, DataTable } from '@gov-nx/ui/web';
import { generateRandomNumber } from '@gov-nx/utils/common';

export const IdentityDocumentSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<DataTable
				noStripped
				responsive>
				<tbody>
					{Array.from({ length: 3 }).map((_, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<tr key={index}>
							<td className="md:w-1/2">
								<GovSkeleton
									width={generateRandomNumber(20, 60) + '%'}
									height="18px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</td>
							<td className="md:w-1/2">
								<GovSkeleton
									width={generateRandomNumber(20, 60) + '%'}
									height="18px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</DataTable>
			<GovSkeleton
				width="200px"
				height="40px"
				aria-label={t('loading.wcag.processing')}
				className="mt-4"
			/>
		</ContentLayout>
	);
};
